import { createGlobalStyle } from 'styled-components';
import SourceSansProLight from '@/assets/fonts/SourceSansPro-Light.ttf';
import SourceSansProRegular from '@/assets/fonts/SourceSansPro-Regular.ttf';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Source Sans Pro';
    font-weight: 300;
    src: url(${SourceSansProLight});
  }
  @font-face {
    font-family: 'Source Sans Pro';
    font-weight: 400;
    src: url(${SourceSansProRegular});
  }

  html {
    font-size: 16px;
    font-family: 'Source Sans Pro', sans-serif;
  }

  body {
    font-family: 'Source Sans Pro', sans-serif;
    color: ${({ theme }) => theme.system.neutral.text.primary} !important;
    /* iOS 26+ Safari: ensures backdrops cover the full visual viewport
     after the page is scrolled. */
    position: relative;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-underline-offset: 2px;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.system.neutral.text.primary};
  }


  /* Base UI portal setup: creates a separate stacking context so portaled
     popups (Dialog, Popover, etc.) always render above page content. */
  #root {
    isolation: isolate;
  }

  /* Target Chrome, Safari, Edge, and Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Target Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export default GlobalStyles;
